
import ApiService from '@/services/configs/api.service'

const GrilleTarifaireService = {

    get() {
      return ApiService.get("grilleTarifaires");
    },
   
   
    create(params) {
      return ApiService.post("admin/grilleTarifaires", params);
    },

    update(slug, params) {
      return ApiService.put(`admin/grilleTarifaires/${slug}`,params);
    },

    destroy(slug) {
      return ApiService.delete(`admin/grilleTarifaires/${slug}`);
    },

    getPrice(params){
      return ApiService.post("grilleTarifaire/filtre",params)
    }


  };

  export default GrilleTarifaireService;
  